import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.groupByKey
        ? _c(
            VTabs,
            {
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _vm._l(_vm.languages, function (l) {
                return [
                  _c(VTab, { key: l.code }, [
                    _vm._v("\n        " + _vm._s(l.name) + "\n      "),
                  ]),
                  _vm._v(" "),
                  _c(
                    VTabItem,
                    { key: l.code, staticClass: "pt-2" },
                    [
                      _vm._l(_vm.value, function (v, k) {
                        return [
                          _vm.defs[k] !== undefined
                            ? _c(_vm.defs[k].component, {
                                key: k + "_" + l.code,
                                tag: "component",
                                attrs: { label: k, outlined: "" },
                                model: {
                                  value: v[l.code],
                                  callback: function ($$v) {
                                    _vm.$set(v, l.code, $$v)
                                  },
                                  expression: "v[l.code]",
                                },
                              })
                            : _c(VTextField, {
                                key: k + "_" + l.code,
                                attrs: { label: k, outlined: "" },
                                model: {
                                  value: v[l.code],
                                  callback: function ($$v) {
                                    _vm.$set(v, l.code, $$v)
                                  },
                                  expression: "v[l.code]",
                                },
                              }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          )
        : _c(
            VTabs,
            {
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _vm._l(_vm.value, function (v, k) {
                return [
                  _c(VTab, { key: k }, [
                    _vm._v("\n        " + _vm._s(k) + "\n      "),
                  ]),
                  _vm._v(" "),
                  _c(
                    VTabItem,
                    { key: k, staticClass: "pt-2" },
                    [
                      _vm._l(_vm.languages, function (l) {
                        return [
                          _vm.defs[k] !== undefined
                            ? _c(_vm.defs[k].component, {
                                key: k + "_" + l.code,
                                tag: "component",
                                attrs: { label: k, outlined: "" },
                                model: {
                                  value: v[l.code],
                                  callback: function ($$v) {
                                    _vm.$set(v, l.code, $$v)
                                  },
                                  expression: "v[l.code]",
                                },
                              })
                            : _c(VTextField, {
                                key: k + "_" + l.code,
                                attrs: { label: k, outlined: "" },
                                model: {
                                  value: v[l.code],
                                  callback: function ($$v) {
                                    _vm.$set(v, l.code, $$v)
                                  },
                                  expression: "v[l.code]",
                                },
                              }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }